export const searchBoxStyles: any = () => ({
  root: {
    width: '100%'
  },
  field: [
    {
      paddingLeft: 10
    },
    {
      selectors: {
        ':focus': {
          outline: 'none !important'
        }
      }
    }
  ]
})